import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, DollarSign, Users, Clock, ExternalLink, Sparkles, TrendingUp, Filter, Check } from 'lucide-react';

// Static projects data as fallback - ALL 14 PROJECTS
const STATIC_PROJECTS = [
  {
    "id": "1",
    "name": "SAW Platform - Integrated Business Solutions",
    "description": "Comprehensive business management platform integrating multiple SAW services including gold trading, remittance, and precious metals testing for streamlined operations.",
    "sector": "fintech",
    "client": "SAW Group",
    "location": "Hargeisa",
    "country": "Somaliland",
    "budget_usd": 1200000,
    "duration_months": 18,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-02-01T00:00:00",
    "end_date": "2024-08-01T00:00:00",
    "technologies": ["React", "Node.js", "PostgreSQL", "Redis", "Docker", "AWS", "Microservices"],
    "key_features": ["Multi-service integration", "Real-time analytics", "Compliance management", "Mobile applications", "API gateway"],
    "team_size": 12
  },
  {
    "id": "2",
    "name": "SAW Gold Trading Solution",
    "description": "Advanced gold trading platform with real-time pricing, secure transactions, portfolio management, and integrated precious metals testing laboratory systems.",
    "sector": "fintech",
    "client": "SAW Gold",
    "location": "Hargeisa",
    "country": "Somaliland",
    "budget_usd": 950000,
    "duration_months": 15,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-05-01T00:00:00",
    "end_date": "2024-08-01T00:00:00",
    "technologies": ["Angular", "Java", "Spring Boot", "PostgreSQL", "Redis", "WebSocket", "Blockchain"],
    "key_features": ["Real-time gold pricing", "Secure trading engine", "Portfolio tracking", "Laboratory integration", "Mobile trading app"],
    "team_size": 10
  },
  {
    "id": "3",
    "name": "SAW Remit - International Money Transfer Platform",
    "description": "Secure international remittance platform connecting Somaliland with UK and global markets, featuring compliance management, real-time transfers, and mobile applications.",
    "sector": "fintech",
    "client": "SAW Remit",
    "location": "London",
    "country": "UK",
    "budget_usd": 1100000,
    "duration_months": 16,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-03-01T00:00:00",
    "end_date": "2024-07-01T00:00:00",
    "technologies": ["React Native", "Node.js", "MongoDB", "Swift API", "Compliance APIs", "Encryption"],
    "key_features": ["International transfers", "KYC/AML compliance", "Multi-currency support", "Mobile app", "Real-time rates"],
    "team_size": 11
  },
  {
    "id": "4",
    "name": "Smart Logistics Management Platform",
    "description": "Comprehensive IoT and AI-powered logistics management system integrating fleet tracking, warehouse optimization, and delivery management for international shipping company.",
    "sector": "technology",
    "client": "Global Express Solutions Ltd",
    "location": "Mumbai",
    "country": "India",
    "budget_usd": 1650000,
    "duration_months": 18,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-01-15T00:00:00",
    "end_date": "2024-07-15T00:00:00",
    "technologies": ["React", "Node.js", "MongoDB", "IoT", "AI/ML", "Docker", "Kubernetes"],
    "key_features": ["Real-time fleet tracking", "Smart warehouse management", "Route optimization", "Mobile delivery app", "Analytics dashboard"],
    "team_size": 12
  },
  {
    "id": "5",
    "name": "Digital Payment Processing Platform",
    "description": "Modern payment processing platform with real-time transactions, mobile payments, and advanced fraud detection for international fintech company.",
    "sector": "fintech",
    "client": "TechPay International",
    "location": "Karachi",
    "country": "Pakistan",
    "budget_usd": 1800000,
    "duration_months": 24,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2022-06-01T00:00:00",
    "end_date": "2024-06-01T00:00:00",
    "technologies": ["Java", "Spring Boot", "PostgreSQL", "React Native", "Microservices", "Kafka", "Redis"],
    "key_features": ["Real-time transactions", "Mobile payment app", "Fraud detection AI", "API gateway", "Compliance reporting"],
    "team_size": 16
  },
  {
    "id": "6",
    "name": "Healthcare Management System",
    "description": "Integrated clinic management system with patient records, appointment scheduling, and telemedicine for private healthcare network.",
    "sector": "healthcare",
    "client": "MediCare Solutions Private Ltd",
    "location": "Dhaka",
    "country": "Bangladesh",
    "budget_usd": 1200000,
    "duration_months": 15,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-03-01T00:00:00",
    "end_date": "2024-06-01T00:00:00",
    "technologies": ["Angular", "Python", "FastAPI", "PostgreSQL", "WebRTC", "Docker"],
    "key_features": ["Electronic health records", "Telemedicine platform", "Appointment system", "Billing integration", "Mobile app"],
    "team_size": 10
  },
  {
    "id": "7",
    "name": "Mining Operations Analytics Platform",
    "description": "AI-powered analytics platform for optimizing mining operations, equipment monitoring, and safety management for private mining company.",
    "sector": "mining",
    "client": "Apex Mining Industries",
    "location": "Jaipur",
    "country": "India",
    "budget_usd": 950000,
    "duration_months": 12,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-08-01T00:00:00",
    "end_date": "2024-08-01T00:00:00",
    "technologies": ["Python", "TensorFlow", "React", "InfluxDB", "Grafana", "IoT sensors"],
    "key_features": ["Equipment monitoring", "Predictive maintenance", "Safety alerts", "Production optimization", "Real-time dashboards"],
    "team_size": 8
  },
  {
    "id": "8",
    "name": "E-Commerce Platform Development",
    "description": "Scalable e-commerce platform with advanced inventory management, AI-powered recommendations, and multi-vendor support for international marketplace.",
    "sector": "technology",
    "client": "Digital Commerce Solutions",
    "location": "Lahore",
    "country": "Pakistan",
    "budget_usd": 1100000,
    "duration_months": 16,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-05-01T00:00:00",
    "end_date": "2024-09-01T00:00:00",
    "technologies": ["React", "Node.js", "MongoDB", "Elasticsearch", "Redis", "Stripe API"],
    "key_features": ["Multi-vendor marketplace", "AI recommendations", "Real-time inventory", "Mobile app", "Analytics dashboard"],
    "team_size": 11
  },
  {
    "id": "9",
    "name": "Financial Risk Management System",
    "description": "Comprehensive risk management and compliance system for international investment firm with automated reporting and audit trails.",
    "sector": "fintech",
    "client": "Meridian Capital Partners",
    "location": "Chennai",
    "country": "India",
    "budget_usd": 1350000,
    "duration_months": 20,
    "status": "in-progress",
    "completion_percentage": 60,
    "start_date": "2024-02-01T00:00:00",
    "end_date": "2025-10-01T00:00:00",
    "technologies": ["Java", "Spring Boot", "PostgreSQL", "Angular", "Apache Kafka", "Elasticsearch"],
    "key_features": ["Risk assessment", "Portfolio analysis", "Audit trails", "Compliance dashboard", "Automated alerts"],
    "team_size": 14
  },
  {
    "id": "10",
    "name": "Enterprise Resource Planning System",
    "description": "Custom ERP solution for textile manufacturing company with modules for inventory, finance, HR, and production planning with advanced analytics.",
    "sector": "technology",
    "client": "Pacific Textiles Corporation",
    "location": "Faisalabad",
    "country": "Pakistan",
    "budget_usd": 1450000,
    "duration_months": 22,
    "status": "in-progress",
    "completion_percentage": 40,
    "start_date": "2024-03-01T00:00:00",
    "end_date": "2025-12-01T00:00:00",
    "technologies": ["Angular", "C#", ".NET Core", "PostgreSQL", "Power BI", "Azure"],
    "key_features": ["Inventory management", "Financial reporting", "HR module", "Production planning", "Business intelligence"],
    "team_size": 13
  },
  {
    "id": "11",
    "name": "Digital Marketing Analytics Platform",
    "description": "Advanced marketing analytics and campaign management platform with AI-powered insights and automated reporting for digital marketing agency.",
    "sector": "technology",
    "client": "Horizon Digital Marketing",
    "location": "Karachi",
    "country": "Pakistan",
    "budget_usd": 950000,
    "duration_months": 14,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-04-01T00:00:00",
    "end_date": "2024-06-01T00:00:00",
    "technologies": ["Python", "Django", "React", "PostgreSQL", "TensorFlow", "AWS"],
    "key_features": ["Campaign analytics", "AI insights", "Automated reporting", "Client dashboard", "Performance tracking"],
    "team_size": 9
  },
  {
    "id": "12",
    "name": "Supply Chain Management System",
    "description": "Comprehensive supply chain optimization platform with real-time tracking, vendor management, and inventory optimization for manufacturing company.",
    "sector": "technology",
    "client": "Sterling Manufacturing Ltd",
    "location": "Mumbai",
    "country": "India",
    "budget_usd": 1100000,
    "duration_months": 16,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-06-01T00:00:00",
    "end_date": "2024-10-01T00:00:00",
    "technologies": ["Java", "Spring Boot", "React", "MySQL", "Apache Kafka", "Docker"],
    "key_features": ["Supply chain tracking", "Vendor management", "Inventory optimization", "Cost analysis", "Mobile app"],
    "team_size": 11
  },
  {
    "id": "13",
    "name": "Real Estate Management Platform",
    "description": "Complete property management system with tenant management, rent collection, maintenance tracking, and financial reporting for real estate company.",
    "sector": "technology",
    "client": "Premium Properties International",
    "location": "Lahore",
    "country": "Pakistan",
    "budget_usd": 850000,
    "duration_months": 12,
    "status": "in-progress",
    "completion_percentage": 70,
    "start_date": "2024-02-01T00:00:00",
    "end_date": "2025-02-01T00:00:00",
    "technologies": ["Vue.js", "Node.js", "MongoDB", "Express", "Stripe API", "AWS"],
    "key_features": ["Property management", "Tenant portal", "Rent collection", "Maintenance tracking", "Financial reports"],
    "team_size": 8
  },
  {
    "id": "14",
    "name": "Manufacturing Process Optimization",
    "description": "IoT-enabled manufacturing process optimization system with real-time monitoring, quality control, and production analytics for industrial manufacturer.",
    "sector": "technology",
    "client": "Elite Manufacturing Solutions",
    "location": "Chennai",
    "country": "India",
    "budget_usd": 1200000,
    "duration_months": 18,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-02-01T00:00:00",
    "end_date": "2024-08-01T00:00:00",
    "technologies": ["Python", "FastAPI", "React", "InfluxDB", "Grafana", "IoT", "Machine Learning"],
    "key_features": ["Process monitoring", "Quality control", "Production analytics", "Predictive maintenance", "Cost optimization"],
    "team_size": 12
  },
  {
    "id": "15",
    "name": "Educational Technology Platform",
    "description": "Comprehensive online learning management system with video streaming, assessments, progress tracking, and certification management for educational institute.",
    "sector": "technology",
    "client": "Global Learning Institute",
    "location": "Dhaka",
    "country": "Bangladesh",
    "budget_usd": 900000,
    "duration_months": 15,
    "status": "completed",
    "completion_percentage": 100,
    "start_date": "2023-07-01T00:00:00",
    "end_date": "2024-10-01T00:00:00",
    "technologies": ["React", "Node.js", "MongoDB", "WebRTC", "AWS", "Cloudflare"],
    "key_features": ["Video streaming", "Online assessments", "Progress tracking", "Certification system", "Mobile learning"],
    "team_size": 10
  }
];

export const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        
        // Try to load from JSON files
        let projectsData = [];
        
        try {
          // Try primary location
          const response = await fetch('/projects.json');
          if (response.ok) {
            const data = await response.json();
            projectsData = data.projects || [];
          } else {
            // Try backup location
            const backupResponse = await fetch('/api/projects.json');
            if (backupResponse.ok) {
              const backupData = await backupResponse.json();
              projectsData = backupData.projects || [];
            }
          }
        } catch (fetchError) {
          console.warn('Failed to load JSON files, using static data:', fetchError);
        }
        
        // Use static data if JSON files failed to load
        if (projectsData.length === 0) {
          projectsData = STATIC_PROJECTS;
        }
        
        setProjects(projectsData);
        setFilteredProjects(projectsData);
        setError(null);
      } catch (err) {
        console.error('Error loading projects:', err);
        // Fallback to static data
        setProjects(STATIC_PROJECTS);
        setFilteredProjects(STATIC_PROJECTS);
        setError(null); // Don't show error since we have fallback data
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    let filtered = projects;

    if (activeFilter !== 'all') {
      filtered = filtered.filter(project => project.sector === activeFilter);
    }

    if (selectedStatus !== 'all') {
      filtered = filtered.filter(project => project.status === selectedStatus);
    }

    setFilteredProjects(filtered);
  }, [projects, activeFilter, selectedStatus]);

  const formatBudget = (budget) => {
    return `$${(budget / 1000000).toFixed(1)}M`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'in-progress':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'planning':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'on-hold':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getSectorIcon = (sector) => {
    switch (sector) {
      case 'technology':
        return '💻';
      case 'fintech':
        return '💳';
      case 'healthcare':
        return '🏥';
      case 'mining':
        return '⛏️';
      case 'government':
        return '🏛️';
      case 'banking':
        return '🏦';
      case 'logistics':
        return '🚚';
      default:
        return '📊';
    }
  };

  const sectors = [
    { id: 'all', name: 'All Sectors', count: projects.length },
    { id: 'technology', name: 'Technology', count: projects.filter(p => p.sector === 'technology').length },
    { id: 'fintech', name: 'FinTech', count: projects.filter(p => p.sector === 'fintech').length },
    { id: 'healthcare', name: 'Healthcare', count: projects.filter(p => p.sector === 'healthcare').length },
    { id: 'mining', name: 'Mining', count: projects.filter(p => p.sector === 'mining').length },
    { id: 'government', name: 'Government', count: projects.filter(p => p.sector === 'government').length },
    { id: 'banking', name: 'Banking', count: projects.filter(p => p.sector === 'banking').length },
    { id: 'logistics', name: 'Logistics', count: projects.filter(p => p.sector === 'logistics').length },
  ];

  const statuses = [
    { id: 'all', name: 'All Status' },
    { id: 'completed', name: 'Completed' },
    { id: 'in-progress', name: 'In Progress' },
    { id: 'planning', name: 'Planning' },
    { id: 'on-hold', name: 'On Hold' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 }
    },
    hover: {
      scale: 1.02,
      y: -5,
      transition: { duration: 0.3 }
    }
  };

  const stats = {
    totalValue: projects.reduce((sum, p) => sum + p.budget_usd, 0),
    completedProjects: projects.filter(p => p.status === 'completed').length,
    activeProjects: projects.filter(p => p.status === 'in-progress').length,
    totalTeamMembers: projects.reduce((sum, p) => sum + p.team_size, 0)
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-32 pb-16">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center min-h-[400px]">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
              className="w-12 h-12 border-4 border-[#1F3C88] border-t-transparent rounded-full"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-32 pb-16">
      <motion.div
        className="container mx-auto px-6"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Hero Section */}
        <motion.div className="text-center mb-16" variants={itemVariants}>
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#1F3C88]/10 to-[#FF5C8A]/10 px-4 py-2 rounded-full mb-6">
            <Sparkles className="w-5 h-5 text-[#1F3C88]" />
            <span className="text-sm font-semibold text-[#1F3C88]">Our Project Portfolio</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-[#1F3C88] to-[#FF5C8A] bg-clip-text text-transparent mb-6">
            Delivered Excellence
          </h1>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Discover our successful projects spanning multiple sectors and regions. From cutting-edge technology 
            solutions to large-scale infrastructure projects, we deliver measurable results.
          </p>

          {/* Stats Cards */}
          <div className="grid md:grid-cols-4 gap-6 mb-12">
            <motion.div
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-[#1F3C88] to-[#FF5C8A] rounded-lg mb-4 mx-auto">
                <DollarSign className="w-6 h-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">${(stats.totalValue / 1000000).toFixed(1)}M+</div>
              <div className="text-gray-600">Total Project Value</div>
            </motion.div>

            <motion.div
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-lg mb-4 mx-auto">
                <Check className="w-6 h-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">{stats.completedProjects}</div>
              <div className="text-gray-600">Completed Projects</div>
            </motion.div>

            <motion.div
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg mb-4 mx-auto">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">{stats.activeProjects}</div>
              <div className="text-gray-600">Active Projects</div>
            </motion.div>

            <motion.div
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
            >
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg mb-4 mx-auto">
                <Users className="w-6 h-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">{stats.totalTeamMembers}+</div>
              <div className="text-gray-600">Team Members</div>
            </motion.div>
          </div>
        </motion.div>

        {/* Filters */}
        <motion.div className="mb-8" variants={itemVariants}>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            {/* Sector Filter */}
            <div>
              <h3 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                <Filter className="w-4 h-4 mr-2" />
                Filter by Sector
              </h3>
              <div className="flex flex-wrap gap-2">
                {sectors.map((sector) => (
                  <button
                    key={sector.id}
                    onClick={() => setActiveFilter(sector.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                      activeFilter === sector.id
                        ? 'bg-[#1F3C88] text-white shadow-lg transform scale-105'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
                    }`}
                  >
                    {sector.name} ({sector.count})
                  </button>
                ))}
              </div>
            </div>

            {/* Status Filter */}
            <div>
              <h3 className="text-sm font-semibold text-gray-700 mb-3">Status</h3>
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="px-4 py-2 border border-gray-200 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#1F3C88]"
              >
                {statuses.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </motion.div>

        {/* Projects Grid */}
        <motion.div 
          className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8"
          variants={containerVariants}
        >
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden group"
              variants={cardVariants}
              whileHover="hover"
              initial="hidden"
              animate="visible"
              transition={{ delay: index * 0.1 }}
            >
              {/* Project Header */}
              <div className="p-6 pb-4">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">{getSectorIcon(project.sector)}</div>
                    <div>
                      <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(project.status)}`}>
                        {project.status.charAt(0).toUpperCase() + project.status.slice(1).replace('-', ' ')}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-[#1F3C88]">{formatBudget(project.budget_usd)}</div>
                    <div className="text-xs text-gray-500">USD</div>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#1F3C88] transition-colors">
                  {project.name}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {project.description}
                </p>

                {/* Client & Location */}
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-1">
                    <span className="font-medium">{project.client}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <MapPin className="w-4 h-4" />
                    <span>{project.country}</span>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="mb-4">
                  <div className="flex justify-between text-xs text-gray-500 mb-1">
                    <span>Progress</span>
                    <span>{project.completion_percentage}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <motion.div
                      className="bg-gradient-to-r from-[#1F3C88] to-[#FF5C8A] h-2 rounded-full"
                      initial={{ width: 0 }}
                      animate={{ width: `${project.completion_percentage}%` }}
                      transition={{ duration: 1, delay: index * 0.1 }}
                    />
                  </div>
                </div>
              </div>

              {/* Project Details */}
              <div className="px-6 pb-4">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Calendar className="w-4 h-4" />
                    <span>{formatDate(project.start_date)}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Clock className="w-4 h-4" />
                    <span>{project.duration_months}mo</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Users className="w-4 h-4" />
                    <span>{project.team_size} members</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <span className="w-4 h-4 text-center">📍</span>
                    <span>{project.location}</span>
                  </div>
                </div>
              </div>

              {/* Technologies */}
              <div className="px-6 pb-4">
                <div className="flex flex-wrap gap-1">
                  {project.technologies.slice(0, 4).map((tech, i) => (
                    <span
                      key={i}
                      className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-md"
                    >
                      {tech}
                    </span>
                  ))}
                  {project.technologies.length > 4 && (
                    <span className="px-2 py-1 bg-gray-100 text-gray-500 text-xs rounded-md">
                      +{project.technologies.length - 4} more
                    </span>
                  )}
                </div>
              </div>

              {/* Key Features */}
              <div className="px-6 pb-6">
                <h4 className="text-sm font-semibold text-gray-700 mb-2">Key Features:</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  {project.key_features.slice(0, 3).map((feature, i) => (
                    <li key={i} className="flex items-center space-x-2">
                      <div className="w-1.5 h-1.5 bg-[#1F3C88] rounded-full"></div>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* No Results Message */}
        {filteredProjects.length === 0 && (
          <motion.div
            className="text-center py-16"
            variants={itemVariants}
          >
            <div className="text-6xl mb-4">🔍</div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No projects found</h3>
            <p className="text-gray-500">Try adjusting your filters to see more results.</p>
          </motion.div>
        )}

        {/* Call to Action */}
        <motion.div
          className="text-center mt-16 py-12 bg-gradient-to-r from-[#1F3C88]/5 to-[#FF5C8A]/5 rounded-3xl"
          variants={itemVariants}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Ready to Start Your Next Project?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Join our portfolio of successful clients. Let's discuss how we can deliver 
            exceptional results for your next project.
          </p>
          <motion.a
            href="/request-service"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#1F3C88] to-[#FF5C8A] text-white px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all duration-300"
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Start Your Project</span>
            <ExternalLink className="w-5 h-5" />
          </motion.a>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Projects;